<template>
    <div class="pc">
        <div class="swiper-first">
            <div class="swiper-wrapper">
                <div class="swiper-slide page1">
                    <img src="../assets/images/6.jpg" alt="">
                </div>
                <div class="swiper-slide page2">
                    <img src="../assets/images/2.jpg" alt="">
                </div>
                <div class="swiper-slide page3">
                    <img src="../assets/images/3.jpg" alt="">
                </div>
            </div>
        </div>
        <div>
            <div class="qrcode">
                <img src="../assets/images/logo.png" alt="">
                <img src="../assets/images/qrcode.jpg" alt="">
                <p> 扫一扫了解更多资讯</p>
            </div>
            <div class="container" style="overflow:hidden">
                <div class="hot-work" v-show="NoseList[1]&&NoseList[1].list.length">
                    <div class="panel panel-default">
                        <div class="panel-heading">小学教辅推荐</div>
                        <div class="panel-body">
                            <div class="swiper-container swiper-container-list">
                                <div class="swiper-wrapper">
                                    <div v-for="one in NoseList[1]&&NoseList[1].list" class="swiper-slide">
                                        <div class="show-block">
                                            <a v-link="'/index/norisukeInfo?id='+one.id">
                                                <img :src="one.images" @error="imgError($index)">
                                                <div class="float-title">
                                                    <p>{{one.name}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hot-work" v-show="NoseList[2]&&NoseList[2].list.length">
                    <div class="panel panel-default">
                        <div class="panel-heading">中学教辅推荐</div>
                        <div class="panel-body">
                            <div class="swiper-container swiper-container-list">
                                <div class="swiper-wrapper">
                                    <div v-for="one in NoseList[2]&&NoseList[2].list" class="swiper-slide">
                                        <div class="show-block">
                                            <a v-link="'/index/norisukeInfo?id='+one.id">
                                                <img :src="one.images" @error="imgError($index)">
                                                <div class="float-title">
                                                    <p>{{one.name}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hot-work" v-show="NoseList[3]&&NoseList[3].list.length">
                    <div class="panel panel-default">
                        <div class="panel-heading">高中教辅推荐</div>
                        <div class="panel-body">
                            <div class="swiper-container swiper-container-list">
                                <div class="swiper-wrapper">
                                    <div v-for="one in NoseList[3]&&NoseList[3].list" class="swiper-slide">
                                        <div class="show-block">
                                            <a v-link="'/index/norisukeInfo?id='+one.id">
                                                <img :src="one.images" @error="imgError($index)">
                                                <div class="float-title">
                                                    <p>{{one.name}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hot-work" v-show="NoseList[9]&&NoseList[9].list.length">
                    <div class="panel panel-default">
                        <div class="panel-heading">新品字帖推荐</div>
                        <div class="panel-body">
                            <div class="swiper-container swiper-container-list">
                                <div class="swiper-wrapper">
                                    <div v-for="one in NoseList[9]&&NoseList[9].list" class="swiper-slide">
                                        <div class="show-block">
                                            <a v-link="'/index/norisukeInfo?id='+one.id">
                                                <img :src="one.images" @error="imgError($index)">
                                                <div class="float-title">
                                                    <p>{{one.name}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hot-work" v-show="NoseList[6]&&NoseList[6].list.length">
                    <div class="panel panel-default">
                        <div class="panel-heading">其他图书推荐</div>
                        <div class="panel-body">
                            <div class="swiper-container swiper-container-list">
                                <div class="swiper-wrapper">
                                    <div v-for="one in NoseList[6]&&NoseList[6].list" class="swiper-slide">
                                        <div class="show-block">
                                            <a v-link="'/index/norisukeInfo?id='+one.id">
                                                <img :src="one.images" @error="imgError($index)">
                                                <div class="float-title">
                                                    <p>{{one.name}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="hot-work" v-show="shopList.list&&shopList.list.length">
                    <div class="panel panel-default">
                        <div class="panel-heading">热点书店推荐</div>
                        <div class="panel-body">
                            <div class="swiper-container swiper-container-shop">
                                <div class="swiper-wrapper">
                                    <div v-for="one in shopList.list" class="swiper-slide">
                                        <div class="show-block">
                                            <a v-link="'/index/shopInfo?id='+one.id">
                                                <img :src="one.logo" @error="imgError($index)">
                                                <div class="float-title">
                                                    <p>{{one.name}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    require('swiper');
    import myFooter from './common/footer.vue'
    import M from '../assets/common.js'
    import C from '../assets/config.js'

    export default {
        data: function () {
            return {
                bookList: {},
                shopList: {},
                NoseList: {},
                host: C.host,
                topHeight: "",
                typeName: {},
                noseType: '',

            }
        },
        components: {
            myFooter

        },
        created() {
            var self = this;
            M.getAllType("admin", function (data) {
                self.$set('typeName', data);
                self.loadBook();
                self.loadShop();
                for (var i in self.typeName.general) {
                    self.noseType = i;
                    self.loadNose();
                }

            })
        },
        computed: {},

        ready() {
            let self = this
            setTimeout(function () {
                self.init();
            }, 3000)
        },
        beforeDestroy() {
            window.onscroll = function () {
            }
        },
        methods: {
            init: function () {
                window.onscroll = function () {
                    let height = $(".swiper-first").offset().top - $(window).scrollTop()
                    if (height <= -480) {
                        $(".qrcode").css({
                            "position": "fixed",
                            "top": "20px",
                            "right": "0",
                            "box-shadow": "1px 1px 1px 1px rgba(0, 0, 0, 0.2)"
                        })
                    } else {
                        $(".qrcode").css({
                            "position": "absolute",
                            "top": "520px",
                            "right": "0",
                            "box-shadow": "1px 1px 1px 1px rgba(0, 0, 0, 0)"
                        })
                    }
                }
                this.$nextTick(function () {
                    var swiper = new Swiper('.swiper-container-list', {
                        autoplay: 2000, //可选选项，自动滑动
                        autoplayDisableOnInteraction: false,
                        slidesPerView: 'auto',
                        loop: true
                    });
                    new Swiper('.swiper-container-shop', {
                        autoplay: 2000, //可选选项，自动滑动
                        autoplayDisableOnInteraction: false,
                        slidesPerView: 'auto',
                        loop: this.shopList.list.length>5?true:false
                    });
                    var swiper1 = new Swiper('.swiper-first', {
                        autoplay: 3000, //可选选项，自动滑动
                        loop: true,
                    });
                });
            },
            imgError: function () {
                //  this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
            },
            // 查询书籍
            loadBook: function () {
                let url = this.host + "wuyan/user/book",
                    params = {
                        pageSize: 20
                    },
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        data.data = {list: [], pageNo: 1, totalCount: 0}
                    }
                    self.$set("bookList", data.data);
                }, 'get');
            },
            loadShop: function () {
                let url = this.host + "wuyan/user/shop/all",
                    params = {
                        pageSize: 20
                    },
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        data.data = {list: [], pageNo: 1, totalCount: 0}
                    } else {
                        self.$set("shopList", data.data);

                    }
                }, 'get');
            },
            //查询教辅
            loadNose: function () {
                let url = this.host + "wuyan/user/norisuke",
                    params = {
                        generalId: this.noseType,
                        pageSize: 20
                    },
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        data.data = {list: [], pageNo: 1, totalCount: 1};
                    } else {
                        self.$set("NoseList[" + params.generalId + "]", data.data);

                    }
                }, 'get');
            },


        }
    }
</script>

<style scoped>
    @import url('../assets/swiper/swiper-3.4.0.min.css');

    .pc {
        width: 100%;
        overflow: hidden;
    }

    .item img {
        width: 100%;
        height: 760px;
    }

    .swiper-container .swiper-slide {
        height: 180px;
        border: 1px solid #ccc;
        width: 180px;
        margin: 20px
    }

    /*.con1 {
        width: 300px;
        height: 300px;
        background: white;
        margin: 20px
    }*/

    .con1 {
    }

    /*热门课件推荐*/

    .hot-work {
        margin: 10px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12);
    }

    .show-block {
        position: relative;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.4);
        min-height: 151px;
    }

    .show-block img {
        height: 150px;
        display: block;
        margin: auto;
    }

    .float-title {
        background: rgba(0, 0, 0, 0.8);
        text-decoration: none;
        color: white;
        width: 100%;
        height: 40px;
        bottom: -27px;
        font-family: 微软雅黑;
        display: flex;
        align-items: center;
    }

    .float-title p {
        margin: 0;
    }

    .qrcode {
        /*box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);*/
        width: 160px;
        /*position: fixed;
        top: 200px;*/
        position: absolute;
        right: 0;
        background: white;
        z-index: 10
    }

    .qrcode img {
        width: 150px;
        display: block;
        margin: 0 auto;
    }

    .qrcode > p {
        text-indent: 24px;
        font-size: 12px;
        font-weight: bolder;
    }

    .swiper-first .swiper-slide {
        text-align: center
    }

    .swiper-first .swiper-slide img {
        width: 1100px;
    }

    .page1.swiper-slide {
        background: #FFD200
    }

    .page2.swiper-slide {
        background: #8DD5E4
    }

    .page3.swiper-slide {
        background: #179BDC
    }
</style>


// WEBPACK FOOTER //
// pc.vue?6177ec1a